var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Form',{attrs:{"form":_vm.form,"model":_vm.model}})
}
var staticRenderFns = []

export { render, staticRenderFns }